/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import _ from 'lodash';

import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';
import { trimComma } from '@/utils';

interface Props {
  acte: Acte;
}

const ActeTableLineNaissance = ({ acte }: Props) => (
  <>
    <Table.Cell content={_date.short(acte.dateNaissance ?? '')} />
    <Table.Cell content={trimComma(acte.nomClassementEnfant)} />
    <Table.Cell
      content={[acte.nomClassementPere, acte.nomClassementMere]
        .filter((v) => !_.isEmpty(v))
        .map(trimComma)
        .join(' - ')}
    />
  </>
);

export default ActeTableLineNaissance;
